import { render, staticRenderFns } from "./FuiRule.vue?vue&type=template&id=0071e5e4&"
import script from "./FuiRule.vue?vue&type=script&lang=js&"
export * from "./FuiRule.vue?vue&type=script&lang=js&"
import style0 from "./FuiRule.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports